import moment from 'moment-timezone';
export const GET_SESSIONS_REQUEST = 'GET_SESSIONS_REQUEST';
export const GET_SESSIONS_SUCCESS = 'GET_SESSIONS_SUCCESS';
export const GET_SESSIONS_FAILURE = 'GET_SESSIONS_FAILURE';
export const GET_SESSIONS_TRENDS_REQUEST = 'GET_SESSIONS_TRENDS_REQUEST';
export const GET_SESSIONS_TRENDS_SUCCESS = 'GET_SESSIONS_TRENDS_SUCCESS';
export const GET_SESSIONS_TRENDS_FAILURE = 'GET_SESSIONS_TRENDS_FAILURE';
export const TOGGLE_SESSION = 'TOGGLE_SESSION';
export const TOGGLE_ALL_SESSIONS = 'TOGGLE_ALL_SESSIONS';
export const FILTER_SESSIONS_BY_COUNT_REQUEST = 'FILTER_SESSIONS_BY_COUNT_REQUEST';
export const FILTER_SESSIONS_BY_COUNT = 'FILTER_SESSIONS_BY_COUNT';
export const POST_UNIQUE_TABLE_ID = 'POST_UNIQUE_TABLE_ID';

export function getLastTenSessions() {
  return getSessions(
    moment()
      .subtract(1, 'year')
      .toISOString(),
    moment().toISOString(),
    10
  );
}

export function getSessions(
  fromTime = moment()
    .subtract(2, 'year')
    .toISOString(),
  toTime = moment().toISOString(),
  limit = null
) {
  return {
    type: GET_SESSIONS_REQUEST,
    payload: { fromTime, toTime, limit }
  };
}

export function toggleSession(sessionKey, isSelected, uniqueTableId) {
  return {
    type: TOGGLE_SESSION,
    payload: { sessionKey, isSelected, uniqueTableId }
  };
}

export function toggleAllSessions(isSelected = true, uniqueTableId) {
  return {
    type: TOGGLE_ALL_SESSIONS,
    payload: { isSelected, uniqueTableId }
  };
}

export function filterSessionsByCount(filterOptions) {
  let { registrantRange, attendeeRange, searchString } = filterOptions;

  return {
    type: FILTER_SESSIONS_BY_COUNT_REQUEST,
    payload: { registrantRange, attendeeRange, searchString }
  };
}

export function postTableId(uniqueTableId) {
  return {
    type: POST_UNIQUE_TABLE_ID,
    payload: { uniqueTableId }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/Sessions/SessionsActions.js